import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ChangelogPage } from "@/components/changelog/changelog-page";
import { parseChangelogSearch, type ChangelogSearch } from "@/components/changelog/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/changelog")({
  // Which entries are listed and which one is open live in the URL and
  // nowhere else. Whatever the URL says, this returns a page that can be
  // drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): ChangelogSearch =>
    parseChangelogSearch(search),
  component: ChangelogRoute,
});

function ChangelogRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: ChangelogSearch) => void navigate({ search: next }),
    [navigate],
  );
  // Keyed by project: the active row is one project's.
  return <ChangelogPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
